// Top-bar chain-mastery dots: one dot per current-song coach passage, colored by how
// much of that chain is mastered (dim → yellow → blue → green). A self-contained unit
// (build the element, push new chain states); change-detected so the DOM only rebuilds
// when a dot actually changes colour. Pure draw glue — no engine import.

type DotLevel = "none" | "learning" | "firming" | "mastered";

export interface ChainProgress {
  fraction: number;
  done: boolean;
}

/** Mastery fraction (+ done) → dot level. done wins; else thresholds on the fraction. */
export function dotLevel({ fraction, done }: ChainProgress): DotLevel {
  if (done || fraction >= 1) return "mastered";
  if (fraction >= 0.5) return "firming";
  if (fraction > 0) return "learning";
  return "none";
}

const FILL: Record<DotLevel, string> = {
  none: "transparent",
  learning: "#e6c84d",
  firming: "#4d8fe6",
  mastered: "#3ddc84",
};
const STROKE: Record<DotLevel, string> = {
  none: "#666",
  learning: "#e6c84d",
  firming: "#4d8fe6",
  mastered: "#3ddc84",
};

export function buildChainDots(): { el: HTMLElement; set(chains: ChainProgress[]): void } {
  const el = document.createElement("span");
  el.className = "chain-dots";
  el.style.cssText = "display:none;gap:4px;align-items:center";
  let key = "__init";
  return {
    el,
    set(chains) {
      const levels = chains.map(dotLevel);
      const k = levels.join(",");
      if (k === key) return;
      key = k;
      el.textContent = "";
      el.style.display = levels.length ? "inline-flex" : "none";
      for (const lvl of levels) {
        const dot = document.createElement("span");
        dot.title = lvl;
        dot.style.cssText = `width:9px;height:9px;border-radius:50%;background:${FILL[lvl]};border:1px solid ${STROKE[lvl]}`;
        el.append(dot);
      }
    },
  };
}
